import { NgModule } from '@angular/core';
import { AccumulatorListComponent } from './accumulator-list/accumulator-list.component';
import { AccumulatorEditComponent } from './accumulator-edit/accumulator-edit.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    AccumulatorListComponent,
    AccumulatorEditComponent
  ],
  imports: [
    SharedModule
  ]
})
export class AccumulatorModule { }
